import Vue from 'vue'
import SvgIcon from './index.vue' // svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = (requireContext: { [key: string]: any }) => requireContext.keys().map(requireContext)
requireAll(req)
